/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CharterContractResponse } from '../models/charter-contract-response';
import { CreateCharterContractRequest } from '../models/create-charter-contract-request';
import { GenericResponse } from '../models/generic-response';
import { GetCharterContractResponse } from '../models/get-charter-contract-response';
import { GetCharterFlightTypeResponse } from '../models/get-charter-flight-type-response';
import { UpdateCharterContractRequest } from '../models/update-charter-contract-request';

/**
 * Charter contract APIs
 */
@Injectable({ providedIn: 'root' })
export class CharterContractService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllCharterContracts()` */
  static readonly GetAllCharterContractsPath = '/api/v1/charter-contracts';

  /**
   * Get list of charter contracts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCharterContracts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCharterContracts$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search contract number, flight number, client
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetCharterContractResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CharterContractService.GetAllCharterContractsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetCharterContractResponse>;
        })
      );
  }

  /**
   * Get list of charter contracts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCharterContracts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCharterContracts(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search contract number, flight number, client
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetCharterContractResponse> {
    return this.getAllCharterContracts$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetCharterContractResponse>
        ): GetCharterContractResponse => r.body
      )
    );
  }

  /** Path part for operation `createCharterContract()` */
  static readonly CreateCharterContractPath = '/api/v1/charter-contracts';

  /**
   * Create charter contract.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCharterContract()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCharterContract$Response(
    params: {
      body: CreateCharterContractRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CharterContractResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CharterContractService.CreateCharterContractPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CharterContractResponse>;
        })
      );
  }

  /**
   * Create charter contract.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCharterContract$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCharterContract(
    params: {
      body: CreateCharterContractRequest;
    },
    context?: HttpContext
  ): Observable<CharterContractResponse> {
    return this.createCharterContract$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<CharterContractResponse>
        ): CharterContractResponse => r.body
      )
    );
  }

  /** Path part for operation `getAllCharterFlightTypes()` */
  static readonly GetAllCharterFlightTypesPath =
    '/api/v1/charter-contracts/flight-types';

  /**
   * Get distinct stored charter flight types.
   *
   * Returns unique flight type strings already saved on non-deleted charter contracts.
   * Exact stored text (case-sensitive). Empty list is success.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCharterFlightTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCharterFlightTypes$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetCharterFlightTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CharterContractService.GetAllCharterFlightTypesPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetCharterFlightTypeResponse>;
        })
      );
  }

  /**
   * Get distinct stored charter flight types.
   *
   * Returns unique flight type strings already saved on non-deleted charter contracts.
   * Exact stored text (case-sensitive). Empty list is success.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCharterFlightTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCharterFlightTypes(
    params?: {},
    context?: HttpContext
  ): Observable<GetCharterFlightTypeResponse> {
    return this.getAllCharterFlightTypes$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetCharterFlightTypeResponse>
        ): GetCharterFlightTypeResponse => r.body
      )
    );
  }

  /** Path part for operation `getCharterContractById()` */
  static readonly GetCharterContractByIdPath = '/api/v1/charter-contracts/{id}';

  /**
   * Get charter contract by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCharterContractById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCharterContractById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CharterContractResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CharterContractService.GetCharterContractByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CharterContractResponse>;
        })
      );
  }

  /**
   * Get charter contract by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCharterContractById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCharterContractById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<CharterContractResponse> {
    return this.getCharterContractById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<CharterContractResponse>
        ): CharterContractResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteCharterContract()` */
  static readonly DeleteCharterContractPath = '/api/v1/charter-contracts/{id}';

  /**
   * Delete charter contract by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCharterContract()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCharterContract$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CharterContractService.DeleteCharterContractPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete charter contract by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCharterContract$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCharterContract(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteCharterContract$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateCharterContract()` */
  static readonly UpdateCharterContractPath = '/api/v1/charter-contracts/{id}';

  /**
   * Update charter contract by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCharterContract()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCharterContract$Response(
    params: {
      id: number;
      body: UpdateCharterContractRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CharterContractResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CharterContractService.UpdateCharterContractPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CharterContractResponse>;
        })
      );
  }

  /**
   * Update charter contract by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCharterContract$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCharterContract(
    params: {
      id: number;
      body: UpdateCharterContractRequest;
    },
    context?: HttpContext
  ): Observable<CharterContractResponse> {
    return this.updateCharterContract$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<CharterContractResponse>
        ): CharterContractResponse => r.body
      )
    );
  }
}
